export { default } from './head'



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/first.js
// module id = 203
// module chunks = 0